import { useMutation } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type SendPushReservationProgramBody = Parameters<typeof apiClient.v2.apiV2ReservationprogramElSendPush>[0]

const sendPushReservationProgram = async (body: SendPushReservationProgramBody) => {
  const { data } = await apiClient.v2.apiV2ReservationprogramElSendPush(body)
  return checkApiResponse(data)
}

export const useV2ReservationProgramSendPushMutation = ({ options }: MutationComposableParams<unknown, SendPushReservationProgramBody> = {}) => {
  return useMutation(() => ({
    mutationFn: sendPushReservationProgram,
    ...resolveMaybeGetter(options ?? {}),
  }))
}
